import * as React from 'react';
import { useLocation } from 'react-router-dom';

const PrivateRoute = ({ component: Component, authenticated }: any) => {
  const location = useLocation();

  React.useEffect(() => {
    if (authenticated === true) {
      return;
    }

    // A full page load rather than a client side redirect: a tab that has been open across a deploy
    // is still running the previous bundle, and signing in again on stale code can fail against
    // newer auth configuration. Reloading picks up the current build first.
    const returnPath = `${location.pathname}${location.search || ''}`;
    window.location.assign(`/login?returnPath=${encodeURIComponent(returnPath)}`);
  }, [authenticated]);

  return authenticated === true ? <Component /> : null;
};

export default PrivateRoute;
